import { render, staticRenderFns } from "./price5.vue?vue&type=template&id=28167bf1"
import script from "./price5.vue?vue&type=script&lang=js"
export * from "./price5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports